export const USER_STATUS = {
  ACTIVE: 'active',
}

export const USER_ROLE = {
  OWNER: 'owner',
  MANAGER: 'manager',
}

export const MANAGER_STATUS = {
  ACTIVE: 'active',
  PENDING: 'pending',
  DISABLED: 'disabled',
}
